import React, { useState } from 'react';
import { useField } from 'formik';
import { getAsterisk } from '../../../userFlows/components/passwordResetForm';
import { Icon } from '../../../../utilities/icomoon-css';

export const MyTextField = ({ label, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <div className="textInputSection">
      <label className="fieldLabel">
        {label}
        {getAsterisk()}
      </label>
      <input className="cardDetailsInput" {...field} {...props} />
      {meta.touched && meta.error ? <ErrorLabel message={meta.error} /> : <></>}
    </div>
  );
};

export const MyPasswordField = ({ label, ...props }: any) => {
  const [passwordShow, setPasswordShow] = useState(false);
  const [field, meta] = useField(props);
  const togglePassword = () => {
    setPasswordShow(!passwordShow);
  };
  return (
    <>
      <label className="fieldLabel">
        {label}
        {getAsterisk()}
      </label>
      <div className="control has-icons-right inputSection">
        <input
          className={`cardDetailsInput ${
            meta.touched && meta.error ? 'invalid' : ''
          }`}
          type={passwordShow ? 'text' : 'password'}
          {...field}
          {...props}
        />
        <span className="icon is-small is-right">
          <a
            className="is-clickable accountIconPassword"
            type="button"
            onClick={() => togglePassword()}
          >
            {passwordShow ? (
              <Icon name="tfw-show-bold-cp" />
            ) : (
              <Icon name="tfw-hide-bold-cp" />
            )}
          </a>
        </span>
        {meta.touched && meta.error ? (
          <ErrorLabel message={meta.error} />
        ) : (
          <> </>
        )}
      </div>
    </>
  );
};

export const ErrorLabel = ({ message }: { message: string }) => {
  return (
    <>
      {message ? (
        <div className="messageContainer">
          <Icon name="tfw-danger-triangle-cp" />
          <div>{message}</div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
